import React from 'react';
import { Input, Button, Form, Select } from 'antd';
import 'pages/dashboard/user/changeProfileUser.css';
import { useNavigate } from 'react-router-dom';
import { useGetUserProfileApi, useUpdateUserApi } from './useUserApi';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import GlobalStore from 'stores/globalStore';

interface dataForm {
  username: string;
  phone: string;
  date_of_birth: string;
  address: string;
}

const ChangeProfileUser: React.FC = () => {
  const [form] = Form.useForm();
  const { Option } = Select;
  let navigate = useNavigate();
  const { update } = useUpdateUserApi();
  const { profileObject } = useGetUserProfileApi();
  const { t } = useTranslation();
  const { currentLanguage } = GlobalStore.useContainer();

  const onUpdateUser = (values: any) => {
    const dataForm: dataForm = {
      username: values.username,
      phone: values.phone,
      date_of_birth:
        values.birthyear + '-' + values.birthmonth + '-' + values.birthday,
      address: values.address
    };
    update(dataForm);
  };

  const getDateOfBirth = (date: string, part: string) => {
    // 2006-10-25
    if (!date || date.length !== 10) {
      return;
    }
    switch (part) {
      case 'day':
        return date.slice(8, 10);
      case 'month':
        return date.slice(5, 7);
      case 'year':
        return date.slice(0, 4);
    }
  };

  return (
    <div className="redeem-code">
       {currentLanguage === 'vi' ? (<Helmet>
        <title>Sửa thông tin đăng nhập ELSA Speak</title>
        <meta
          name="description"
          content="Sửa thông tin đăng nhập tài khoản ELSA Speak. ELSA Speak miễn phí, Pro trọn đời, gói ELSA Oxford Business Result, gói ELSA for Students."
        />
      </Helmet>) :
      <Helmet>
        <title>Profile Update - ELSA Speak</title>
        <meta
          name="description"
          content="ELSA Speak App user profile update for web PC. Redeem promo code ELSA Pro, Oxford Business Result, ELSA for Students, ELSA Speak free."
        />
      </Helmet>}
      <h2>{t('profile.update_profile')}</h2>
      <div className="form-edit">
        {profileObject && (
          <Form
            wrapperCol={{ span: 24 }}
            labelCol={{ span: 8 }}
            layout="horizontal"
            form={form}
            initialValues={{
              layout: 'horizontal',
              username: profileObject?.data?.username,
              phone: profileObject?.data?.phone,
              address: profileObject?.data?.address,
              birthday: getDateOfBirth(
                profileObject?.data?.date_of_birth,
                'day'
              ),
              birthmonth: getDateOfBirth(
                profileObject?.data?.date_of_birth,
                'month'
              ),
              birthyear: getDateOfBirth(
                profileObject?.data?.date_of_birth,
                'year'
              )
            }}
            onFinish={onUpdateUser}
          >
            <Form.Item label={t('profile.user_name')} name="username">
              <Input
                style={{ height: '50px' }}
                placeholder={t('profile.full_name')}
              />
            </Form.Item>

            <Form.Item
              label={t('profile.phone_number')}
              name="phone"
              rules={[
                {
                  pattern: new RegExp(
                    /^(0?)(3[2-9]|5[6|8|9]|7[0|6-9]|8[0-6|8|9]|9[0-4|6-9])[0-9]{7}$/
                  ),
                  message: 'Số điện thoại không hợp lệ'
                }
              ]}
            >
              <Input
                size="large"
                style={{ height: '50px' }}
                placeholder="0987654321"
              />
            </Form.Item>

            <Form.Item label={t('profile.date_of_birth')}>
              <div className="date-of-birth">
                <Form.Item
                  className="birthday-day"
                  name="birthday"
                  rules={[
                    {
                      required: true,
                      pattern: new RegExp(/0[0-9]|1[0-9]|2[0-9]|3[0-1]/),
                      message: 'Ngày sinh không hợp lệ'
                    }
                  ]}
                >
                  <Input
                    size="large"
                    style={{ height: '50px' }}
                    name="BirthDay"
                    type="text"
                    placeholder="01"
                    maxLength={2}
                  />
                </Form.Item>
                <Form.Item 
                  name="birthmonth" 
                  className="birthday-month" 
                  rules={[
                    {
                      required: true,
                      message: 'Tháng sinh không hợp lệ'
                    }
                  ]}>
                  <Select size="large" style={{ height: '50px' }}>
                    <Option value="01">Tháng 1</Option>
                    <Option value="02">Tháng 2</Option>
                    <Option value="03">Tháng 3</Option>
                    <Option value="04">Tháng 4</Option>
                    <Option value="05">Tháng 5</Option>
                    <Option value="06">Tháng 6</Option>
                    <Option value="07">Tháng 7</Option>
                    <Option value="08">Tháng 8</Option>
                    <Option value="09">Tháng 9</Option>
                    <Option value="10">Tháng 10</Option>
                    <Option value="11">Tháng 11</Option>
                    <Option value="12">Tháng 12</Option>
                  </Select>
                </Form.Item>
                <Form.Item
                  className="birthday-year"
                  name="birthyear"
                  rules={[
                    {
                      required: true,
                      pattern: new RegExp(/^(19|20)\d{2}$/),
                      message: 'Năm sinh không hợp lệ'
                    }
                  ]}
                >
                  <Input
                    size="large"
                    style={{ height: '50px' }}
                    id="BirthDayYear"
                    type="text"
                    placeholder="1997"
                    maxLength={4}
                  ></Input>
                </Form.Item>
              </div>
            </Form.Item>

            <Form.Item label={t('profile.address')} name="address">
              <Input
                size="large"
                style={{ height: '50px' }}
                placeholder="Address"
              />
            </Form.Item>
            <div className="form-footer">
              <Button
                type="primary"
                htmlType="button"
                className="form-btn btn_cancle"
                onClick={() => navigate('/')}
              >
                {t('profile.cancel')}
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                className="form-btn btn_submit"
                // loading={isLoading}
              >
                {t('profile.save_profile')}
              </Button>
            </div>
          </Form>
        )}
      </div>
    </div>
  );
};

export default ChangeProfileUser;
